import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { WixAtlasServiceWeb } from '@wix/ambassador-wix-atlas-service-web/http'
import { ISessionManager, SessionManagerSymbol } from 'feature-session-manager'
import type { AddressInputSiteConfig, getPlaceFunction, predictFunction } from './types'
import { name, ComponentType } from './symbols'
import { ComponentWillMount, ViewerComponent } from 'feature-components'
import type { AddressInputProps } from '@wix/thunderbolt-components-native'

const BASE_LINGUIST_HEADER = '|en-us|false|4e8a573a-6b3e-426f-9d2f-5285b7dc90f8'
const metasiteAppDefinitionId = '22bef345-3c5b-4c18-b782-74d4085112ff'

const getPlace: getPlaceFunction = ({ PlacesServiceV2, lang, metaSiteInstance, request }) =>
	PlacesServiceV2()({
		Authorization: metaSiteInstance,
		'x-wix-linguist': `${lang}${BASE_LINGUIST_HEADER}`,
	}).getPlace(request)

const predict: predictFunction = ({ AutocompleteServiceV2, lang, metaSiteInstance, request }) =>
	AutocompleteServiceV2()({
		Authorization: metaSiteInstance,
		'x-wix-linguist': `${lang}${BASE_LINGUIST_HEADER}`,
	}).predict(request)

const addressInputFactory = (
	siteFeatureConfig: AddressInputSiteConfig,
	sessionManager: ISessionManager
): ComponentWillMount<ViewerComponent<AddressInputProps>> => {
	const { externalBaseUrl, atlasWebBaseURL } = siteFeatureConfig
	const { AutocompleteServiceV2, PlacesServiceV2 } = WixAtlasServiceWeb(`${externalBaseUrl}${atlasWebBaseURL}`)

	return {
		componentTypes: [ComponentType],
		componentWillMount(comp) {
			const lang = comp.getProps().lang || 'en'
			const metaSiteInstance = sessionManager.getAppInstanceByAppDefId(metasiteAppDefinitionId) || ''

			comp.updateProps({
				getPlace: (request) => getPlace({ PlacesServiceV2, request, lang, metaSiteInstance }),
				predict: (request) => predict({ AutocompleteServiceV2, request, lang, metaSiteInstance }),
			})
		},
	}
}

export const AddressInput = withDependencies(
	[named(SiteFeatureConfigSymbol, name), SessionManagerSymbol],
	addressInputFactory
)
